export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {
		const loadhash = location.hash.substring(1);
		const faqitems = document.querySelectorAll('.faq-item summary.anchorwrapper');

		if (loadhash != '') {
			var matches = loadhash.match(/\d+$/);
			if (matches) {
				console.log(matches[0]);
				const faqentry = document.querySelector('[name="' + loadhash + '"]')
				if (faqentry.parentElement) {
					faqentry.closest(".faq-item").open = true;
				}
			}
		}
	}
};
